// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wBUOO","delete":"styles_delete__2WCHs","update":"styles_update__1RU6H","add":"styles_add__2o8ga"};